// extracted by mini-css-extract-plugin
export default {"starRating":"starRating_starRating__iW18h","star":"starRating_star__8pzZp","filled":"starRating_filled__BkfTS"};